import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
import { get as _get, has as _has } from "lodash";
import injectables from "@/common/injectables";

export const hasInjectedLanguage = _has(injectables, ["translations"]) && _has(injectables, ["locale"]);
const injectedMessages = _get(injectables, ["translations"]);
const injectedLocale = _get(injectables, ["locale"]);


export const i18n = new VueI18n({
    locale: hasInjectedLanguage ? injectedLocale : "et",
    messages: hasInjectedLanguage ? injectedMessages : { et: {} },
    enableInSFC: true,
    silentFallbackWarn: true,
    silentTranslationWarn: true,
});

